import type { BillingInfo, BillingStatus } from './types'

export function nowIso(): string {
  return new Date().toISOString()
}

export function addDays(days: number, from = new Date()): string {
  const d = new Date(from)
  d.setDate(d.getDate() + days)
  return d.toISOString()
}

export function effectiveStatus(billing?: BillingInfo, isAdmin = false): BillingStatus {
  if (!billing) return 'trial'
  if (isAdmin) return 'active'
  if (billing.status === 'suspended') return 'suspended'
  if (billing.plan === 'monthly') {
    if (billing.activeUntil && Date.parse(billing.activeUntil) >= Date.now()) return 'active'
    return 'expired'
  }
  // trial
  if (billing.trialEnd && Date.parse(billing.trialEnd) >= Date.now()) return 'trial'
  return 'expired'
}

export function daysRemaining(billing?: BillingInfo, isAdmin = false): number {
  if (!billing) return 14
  if (isAdmin) return 0 // Admin: días infinitos (mostraremos "Sin vencimiento" en la UI)
  const target = billing.plan === 'monthly' ? billing.activeUntil : billing.trialEnd
  if (!target) return 0
  const diff = Date.parse(target) - Date.now()
  return Math.max(0, Math.ceil(diff / 86400000))
}

export function statusLabel(status: BillingStatus): { text: string; cls: string } {
  switch (status) {
    case 'active':
      return { text: 'Activo', cls: 'bg-emerald-100 text-emerald-700' }
    case 'trial':
      return { text: 'Trial', cls: 'bg-sky-100 text-sky-700' }
    case 'suspended':
      return { text: 'Suspendido', cls: 'bg-amber-100 text-amber-700' }
    default:
      return { text: 'Vencido', cls: 'bg-rose-100 text-rose-700' }
  }
}
